import React from "react";
import { SESONG_SMS_SPORSMAL } from "../../constants/dekkhotell";

// Kundens ja/nei til sesong-SMS for dekkhotellet (og sykkelhotellet, med egen
// tittel og spørsmål). Eget valg, uavhengig av servicepåminnelser; bare «Ja» får
// SMS. `verdi` er true, false eller null (ikke spurt).
export default function SesongSmsValg({
  verdi,
  onChange,
  idPrefix,
  disabled = false,
  visSporsmal = true,
  tittel = "SMS når det er tid for dekkskift",
  sporsmal = SESONG_SMS_SPORSMAL,
}) {
  const navn = `${idPrefix}-sesongsms`;
  return (
    <fieldset disabled={disabled}>
      <legend className="text-sm font-semibold text-slate-700 mb-1">{tittel}</legend>
      {visSporsmal && <p className="text-sm text-slate-700 mb-2">Spør kunden: «{sporsmal}»</p>}
      <div className="flex flex-wrap gap-4">
        <label className="flex items-center gap-2 text-sm">
          <input type="radio" name={navn} checked={verdi === true} onChange={() => onChange(true)} />
          Ja, send SMS
        </label>
        <label className="flex items-center gap-2 text-sm">
          <input type="radio" name={navn} checked={verdi === false} onChange={() => onChange(false)} />
          Nei takk
        </label>
      </div>
      {verdi == null && !visSporsmal && <p className="text-sm text-slate-600 mt-1">Kunden er ikke spurt ennå.</p>}
    </fieldset>
  );
}
